<template>
  <v-row class="d-flex align-center">
    <v-col class="p-4">
      <v-row>
        <div v-html="itemTitle">
        </div>
      </v-row>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { ModuleItem } from "@/generated/classes/Module";
import { defineComponent, type PropType } from "vue";

export default defineComponent({
  components: {},
  props: {
    item: {
      type: Object as PropType<ModuleItem>,
      required: true
    }
  },
  computed: {
    itemTitle(): string {
      return this.item.label;
    }
  }
})

</script>